import React from 'react';

import { TickCircle } from 'iconsax-react';

import classes from './ExploreCareerFilter.module.scss';


const ExploreCareerFilter = ({ careerPaths, selectedId, handleCareerChange }) => {
    return (
        <div className={`${classes.wrapper} d-flex flex-column gap-3`}>
            {careerPaths.map((career, index) => (
                <div key={index}
                    className={`${selectedId == career.id ? `${classes['career-item']} ${classes['selected']}` : classes['career-item']}`}
                    onClick={() => { handleCareerChange(career.id) }}
                >
                    <TickCircle size={18} />
                    {career?.name}
                </div>
            ))}
        </div>
    );
};

export default ExploreCareerFilter;